<h1 mat-dialog-title>
  {{ model ? 'Editar' : 'Agregar' }}
</h1>

<form [formGroup]="form" (submit)="model ? update(form.value) : create(form.value)" appPermissionControl="P197F0001">
  <div mat-dialog-content>
    <input type="hidden" formControlName="id" appPermissionControl="P197K0001" />

    <mat-form-field class="largoFm" color="accent" appearance="outline">
      <mat-label>Rol</mat-label>
      <input matInput placeholder="Administrador" formControlName="description" required appPermissionControl="P197K0002" />
      <mat-error *ngIf="formValue('description')?.errors?.required">Requerido</mat-error>
    </mat-form-field>

    <mat-form-field class="largoFm" color="accent" appearance="outline">
      <mat-label>Descripción</mat-label>
      <textarea matInput #Definition formControlName="definition" maxlength="200" appPermissionControl="P197K0003"></textarea>
      <mat-hint align="end">{{ Definition.value.length }} / 200</mat-hint>
    </mat-form-field>

    <ng-container>
      <mat-form-field class="largoFm" color="accent" appearance="outline">
        <mat-label>Estados</mat-label>
        <mat-select formControlName="active" required appPermissionControl="P197K0004">
          <mat-option [value]="true"> Activo </mat-option>
          <mat-option [value]="false"> Inactivo </mat-option>
        </mat-select>
        <mat-error *ngIf="formValue('active')?.errors?.required">Requerido</mat-error>
      </mat-form-field>
    </ng-container>
  </div>
  <div mat-dialog-actions>
    <ng-container *ngIf="!loading"
      ><button class="botonFm btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P197B0001">Cancelar</button>
      <button class="botonFm" mat-raised-button color="accent" appPermissionControl="P197B0002">
        {{ model ? 'Actualizar' : 'Guardar' }}
      </button>
    </ng-container>
    <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P197B0003">
      Cargando
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </button>
  </div>
</form>
